<template>
  <div>
    <a-spin :spinning="spinning">
      <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      </base-header>

      <div id="logoDiv" style="display: none;"></div>
      <div class="container-fluid mt--7 spin-content">
        <div class="row">
          <div class="col-auto">
            <router-link :to="{ name: 'pos_documents' }">
              <h6 class="heading-small ml-8" style="color: white">
                ⟵ Back to Pos Documents
              </h6>
            </router-link>
          </div>
        </div>

        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-header px-4 py-3 bg-transparent">
                <div v-if="posDocument.status == 'P'" class="row px-3">
                  <!-- <h6 class="heading-small p-0 m-0">
                    TRANS ID # {{ posDocument.trans_id }}
                  <br/>
                    OR/SI NO # {{ posDocument.invoice_no }}
                  </h6> -->
                  <div
                    v-if="posDocument.is_voided == true"
                    class="col d-flex justify-content-end"
                  >
                    <div type="button" class="btn-sm btn-outline-secondary p-0 px-2 m-0 " >
                      <i class="fas fa-print"> </i>
                      <b class="heading-small p-0 px-2 m-0 mr-2" style="letter-spacing:2px" @click="modalFormPrinting = true"> PRINT </b>
                    </div>
                    <h6 class="heading-small p-0 m-0 mr-2">VOIDED</h6>
                    <i class="fas fa-check-circle text-red"></i>
                  </div>
                  <div v-else class="col d-flex justify-content-end">
                    <div type="button" class="btn-sm btn-outline-secondary p-0 px-2 m-0 " >
                      <i class="fas fa-print"> </i>
                      <b class="heading-small p-0 px-2 m-0 mr-2" style="letter-spacing:2px" @click="modalFormPrinting = true"> PRINT </b>
                    </div>
                    <h6 class="heading-small p-0 m-0 mr-2">POSTED</h6>
                    <i class="fas fa-check-circle text-green"></i>
                  </div>
                </div>

                <div v-else class="row px-3">
                  <!-- <h6 class="heading-small p-0 m-0">
                    TRANS ID # {{ posDocument.trans_id }}
                  </h6> -->
                  <div
                    v-if="posDocument.status == 'V'"
                    class="col d-flex justify-content-end"
                  >
                    <div type="button" class="btn-sm btn-outline-secondary p-0 px-2 m-0 " >
                      <i class="fas fa-print"> </i>
                      <b class="heading-small p-0 px-2 m-0 mr-2" style="letter-spacing:2px" @click="modalFormPrinting = true"> PRINT </b>
                    </div>
                    <h6 class="heading-small p-0 m-0 mr-2">VOIDED</h6>
                    <i class="fas fa-minus-circle text-red"></i>
                  </div>
                  <div
                    v-else-if="posDocument.status == 'R'"
                    class="col d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <span>Credit Memo Balance: <strong>{{ creditMemoBalanceDisplay }}</strong></span>
                    </div>
                    <div class="d-flex align-items-center">
                    <div type="button" class="btn-sm btn-outline-secondary p-0 px-2 m-0 " >

                      <i class="fas fa-print"> </i>
                      <b class="heading-small p-0 px-2 m-0 mr-2" style="letter-spacing:2px" @click="modalFormPrinting = true"> PRINT </b>
                    </div>
                    <h6 class="heading-small p-0 m-0 mr-2">RETURN</h6>
                    <i class="fas fa-minus-circle text-red"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body mx-4">
                <div class="row">
                  <h3 class="font-weight-bold">Header Details</h3>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Site</h6>
                    {{ posDocument.site_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Terminal</h6>
                    {{ posDocument.terminal_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Trans ID</h6>
                    {{ posDocument.trans_id }}
                  </div>
  
                  <div class="col" v-if="posDocument.document_type_code == 'POS' && posDocument.document_trans_code == 'ORO'">
                    <h6 class="heading-small text-muted">Reservation No</h6>
                    {{ posDocument.so_doc }}
                  </div>
                  <div class="col" v-else>
                    <h6 class="heading-small text-muted">OR/SI no</h6>
                    {{ posDocument.invoice_no }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Business Date</h6>
                    {{ posDocument.business_date_formatted }}
                  </div>
                  <div v-if="posDocument.status == 'V'" class="col">
                    <h6 class="heading-small text-muted">Origin Document ID</h6>
                    {{ posDocument.origin_id }}
                  </div>
                </div>
                <hr class="my-3" />
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Total Quantity</h6>
                    <a-input
                      v-model="posDocument.total_quantity"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col"></div>
                  <div class="col"></div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Net Amount</h6>
                    <a-input
                      :value="netAmountDisplay"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">VAT Amount</h6>
                    <a-input
                      :value="vatAmountDisplay"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Total with VAT</h6>
                    <a-input
                      :value="totalWithVatDisplay"
                      style="width: 100%"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 class="font-weight-bold mt-4 ml-8">POS Document Details</h3>
        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body" style="background: #ffffff">
                <div class="table-responsive pt-2">
                  <a-table
                    size="small"
                    :columns="detailsColumn"
                    :dataSource="posDocument.details_pos_document_lines"
                    :pagination="{ pageSize: 10 }"
                  >
                    <template slot="action" slot-scope="text, record">
                      <a-tooltip :title="(!record.cost_info || record.cost_info.length === 0) ? 'No cost info available for this line' : 'View Cost Info'">
                        <a-button
                          type="link"
                          size="small"
                          @click="showCostInfoDrawer(record)"
                          :disabled="!record.cost_info || record.cost_info.length === 0"
                        >
                          <i class="fas fa-ellipsis-v"></i>
                        </a-button>
                      </a-tooltip>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cost Info Drawer -->
        <a-drawer
          title="Cost Information"
          placement="right"
          :width="700"
          :visible="costInfoDrawerVisible"
          @close="costInfoDrawerVisible = false"
        >
          <div v-if="selectedCostInfo && selectedCostInfo.length > 0">
            <a-table
              size="small"
              :columns="costInfoColumns"
              :dataSource="selectedCostInfo"
              :pagination="false"
              :rowKey="(record, index) => index"
              bordered
            />
          </div>
          <div v-else>
            <p>No cost information available for this line.</p>
          </div>
        </a-drawer>

        <h3 class="font-weight-bold mt-4 ml-8">Payments</h3>
        <div class="row mt-2 mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body">
                <a-table
                  size="small"
                  :columns="paymentsColumn"
                  :dataSource="posDocument.details_pos_document_payments"
                  :pagination="{ pageSize: 5 }"
                >
                </a-table>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-4">
          <!-- @click='showAdvancedInfoDiv' -->
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="showAdvancedInfoDiv"
          >
            Other Details {{ showAdvancedInfo ? "↟" : "↡" }}
          </button>
        </div>

        <h3 v-if="showAdvancedInfo" class="font-weight-bold ml-8">
          Other Details
        </h3>
        <div v-if="showAdvancedInfo" class="row mt-2 advanced-info mx-7">
          <div class="col">
            <div class="card shadow">
              <div class="card-body">
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Cashier</h6>
                    {{ posDocument.cashier_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Bagger</h6>
                    {{ posDocument.bagger_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Salesman</h6>
                    {{ posDocument.salesman_name }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Customer</h6>
                    {{ posDocument.customer_name }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Created At</h6>
                    {{ posDocument.created_at }}
                  </div>
                </div>
                <div v-if="posDocument.status == 'V'" class="row mt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">Void Date</h6>
                    {{ posDocument.void_date }}
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Voided By</h6>
                    {{ posDocument.void_by }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
      </div>
      <a-modal title="Form Printing" :visible="modalFormPrinting" :maskClosable = "false" @cancel="modalFormPrinting = false;">
        <div class="row ml-3">
          <div class="col-md-2">
            <label>Printer</label>
          </div>
          <div class="col-md-10">
            <a-select v-model="formPrintPrinter" style="width: 100%" placeholder="Select Printer">
              <a-select-option value="pdf">
                  PDF
              </a-select-option>
              <a-select-option value="receipt">
                  Receipt
              </a-select-option>
            </a-select>
          </div>
        </div>   
        <template slot="footer">
          <a-button v-if="formPrintPrinter == 'pdf'" class="btn-success mr-3" type="button" @click="docPrint('pos_document')">Print</a-button>
          <a-button v-else class="btn-success mr-3" type="button" @click="docPrint('receipt')">Print</a-button>
        </template>
    </a-modal>
    </a-spin>
  </div>
</template>

<script>
// NOTE: line-item columns (with cost/price masking) are defined as the
// `detailsColumn` computed property; cost-info columns as `costInfoColumns`.
const posDocumentPayments = [
        {title: 'Payment Type', dataIndex: 'type'},
        {title: 'Reference Code', dataIndex: 'reference_code'},
        {title: 'First Name', dataIndex: 'first_name'},
        {title: 'Last Name', dataIndex: 'last_name'},
        {title: 'Amount Tender', dataIndex: 'amount_tender', align: "right"},
        {title: 'Amount Paid', dataIndex: 'amount', align: "right"},
        {title: 'Remarks', dataIndex: 'remark'},
        {title: 'Status', dataIndex: 'status'},
        {title: 'Excess', dataIndex: 'excess'}
    ];

import { mapState } from "vuex";
import _ from 'lodash';
import HTTPRequest from "../../controllers/httpRequest.js";
// import moment from 'moment';
import posDocumentFormat from '../../components/posDocumentFormat';
import receiptFormat from '../../components/receiptFormat';
import reportUtils from '../../components/reportUtils';
import secureStorage from '../../controllers/secureStorage';

export default {
  data: function () {
    return {
      spinning: false,
      posDocument: null,
      posDocumentId: null,
      pagination: false,
      paymentsColumn: posDocumentPayments,
      showAdvancedInfo: false,
      total_amount_net_vat: 0,
      total_amount_gross_vat: 0,
      modalFormPrinting: false,
      formPrintPrinter: 'pdf',
      costInfoDrawerVisible: false,
      selectedCostInfo: null,
      accessCostPriceRights: [],
    };
  },
  computed: {
    ...mapState(["endPoint", "serverType"]),
    // Columns with cost/price masking based on Access Cost ('Z') / Access Price ('Y') rights.
    detailsColumn() {
      var rights = this.accessCostPriceRights
      var priceRender = function(text){ return reportUtils.maskTools.maskValue(text, 'Y', rights) }
      return [
        { title: "Description", dataIndex: "description" },
        { title: "Barcode", dataIndex: "barcode" },
        { title: "Stock No.", dataIndex: "stock_no" },
        { title: "Quantity", dataIndex: "quantity", align: "right" },
        { title: "Price", dataIndex: "mod_price", align: "right", customRender: priceRender },
        { title: "Net Price", dataIndex: "price", align: "right", customRender: priceRender },
        { title: "Discount", dataIndex: "discount", align: "right" },
        { title: "Subtotal", dataIndex: "subtotal", align: "right", customRender: priceRender },
        { title: "", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 50, align: "center" },
      ]
    },
    costInfoColumns() {
      var rights = this.accessCostPriceRights
      return [
        { title: "Document Type", dataIndex: "document_type_name" },
        { title: "Document No.", dataIndex: "document_no" },
        { title: "Cost", dataIndex: "cost", align: "right", customRender: function(text){ return reportUtils.maskTools.maskValue(text, 'Z', rights) } },
        { title: "Quantity", dataIndex: "quantity", align: "right" },
        { title: "Ref Line No.", dataIndex: "reference_line_no", align: "center" },
      ]
    },
    creditMemoBalanceDisplay() {
      if (this.posDocument == null) {
        return "-";
      }

      let creditMemoBalance = this.posDocument.credit_memo_balance;
      if (creditMemoBalance == null) {
        creditMemoBalance = this.posDocument.cm_balance;
      }

      return creditMemoBalance == null ? "-" : Number(creditMemoBalance).toFixed(2);
    },
    computedPayments() {
      if (!this.posDocument || !this.posDocument.details_pos_document_payments) return [];
      return this.posDocument.details_pos_document_payments.map(p => {
        let excess = Number(p.excess) || 0;
        if (excess === 0 && Number(p.amount_tender) > Number(p.amount)) {
          excess = Number(p.amount_tender) - Number(p.amount);
        }
        return { ...p, computed_excess: excess.toFixed(2) };
      });
    },
    // Masked ('Y' = price) display values for the amount summary fields.
    netAmountDisplay() {
      return reportUtils.maskTools.maskValue(this.total_amount_net_vat, 'Y', this.accessCostPriceRights)
    },
    vatAmountDisplay() {
      return reportUtils.maskTools.maskValue(this.posDocument ? this.posDocument.amount_tax : '', 'Y', this.accessCostPriceRights)
    },
    totalWithVatDisplay() {
      return reportUtils.maskTools.maskValue(this.posDocument ? this.posDocument.amount_due : '', 'Y', this.accessCostPriceRights)
    },
  },
  mounted: async function () {
    this.spinning = true;
    this.posDocumentId = this.$attrs.posDocumentId;

    // Load Access Cost/Price rights (system_module_id 123): 'Z' = cost, 'Y' = price.
    var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
    if (accessCostPriceRightsRequest && _.isEmpty(accessCostPriceRightsRequest.access_rights) == false) {
      this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123] || []
    } else {
      this.accessCostPriceRights = []
    }

    this.posDocument = await HTTPRequest.getRequest(
      this.endPoint + "pos_documents/" + this.posDocumentId,
      null,
      null
    );

    this.total_amount_net_vat =
      Number(this.posDocument.amount_net_vat) +
      Number(this.posDocument.amount_net_non_vat) +
      Number(this.posDocument.amount_net_zero_rated);
    // this.posDocument.created_at = moment(this.posDocument.created_at).format('MM/DD/YYYY hh:mm')
    this.spinning = false;

    // Fix: S3 image CORS error in jsPDF
    this.$nextTick(() => {
      const corsImageModified = new Image();
      corsImageModified.crossOrigin = "Anonymous";
      corsImageModified.id = "logobarter";
      corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
      const logoDivElement = document.getElementById("logoDiv");
      logoDivElement.appendChild(corsImageModified);
    });

  },
  methods: {
    showAdvancedInfoDiv() {
      this.showAdvancedInfo = !this.showAdvancedInfo;
    },
    showCostInfoDrawer(record) {
      this.selectedCostInfo = record.cost_info || null;
      this.costInfoDrawerVisible = true;
    },
    docPrint(format, opt){
      if(format == "pos_document"){
        posDocumentFormat.print(this.endPoint, this.posDocumentId);
      } else if (format == "receipt"){
        receiptFormat.print(this.endPoint, this.posDocumentId);
      }
      this.modalFormPrinting = false;
    }
  },
};
</script>

<style>
</style>
